import React from 'react'

const SuspendedBanner = ({ statusValue }) => {
  if (statusValue !== 'suspended') return null

  return (
    <div
      role="alert"
      className="mb-4 rounded-lg border border-orange-300 bg-orange-50 px-4 py-3 text-sm text-orange-900"
    >
      <span className="font-semibold">Suspended.</span>{' '}
      Do not provide services until the payment plan is restored to good standing.
    </div>
  )
}

export default SuspendedBanner
